module.exports = __webpack_public_path__ + "static/01-8df78a5f2ffa6c967228f4143fe8db21.jpg";